import styled from 'react-emotion'
import themeVars from 'ui_theme/site/globals/site.variables'

import { Avatar } from 'shared/ui'

export default styled(Avatar)`
  float: left;
  margin-right: ${themeVars.tiny};
`
